// utils/exportToExcel.js
import * as XLSX from 'xlsx';

export const exportToExcel = (data, filename = 'TestCases.xlsx', sheetName = 'Test Cases') => {
  // Create a worksheet from the data
  const worksheet = XLSX.utils.json_to_sheet(data);

  // Create a new workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // Generate the excel file
  XLSX.writeFile(workbook, filename);
};
